/* src/app/agent-builder/agent-builder-prompt/agent-builder-prompt.component.scss */
.ia-prompt-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: auto;
  min-height: 0;
}
.ia-textarea {
  width: 100%;
  font-size: 14px;
}
.ia-actions {
  text-align: right;
  display: flex;
  gap: 10px;
}
.ia-response {
  display: flex;
  height: calc(100vh - 490px);
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
  overflow: auto;
  padding: 10px;
}
.response-item {
  max-width: 100%;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.4;
  word-break: break-word;
  position: relative;
  width: 100%;
}
.user-question {
  max-width: 90%;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.4;
  position: relative;
}
.left {
  align-self: flex-start;
  background-color: #f0f0f0;
  border-left: 3px solid #1890ff;
}
.right {
  align-self: flex-end;
  background-color: #e6f7ff;
  border-right: 3px solid #52c41a;
  width: 100%;
  text-align: end;
}
.feedback {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 4px;
}
.id-session {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 4px;
  font-size: 12px;
}
.ia-loading {
  text-align: center;
  margin: 12px 0;
}
.loading-gif {
  width: 32px;
  height: 32px;
}
.ia-input-area {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 8px;
}
.ia-prompt-card-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
p {
  width: 95%;
}
.spin-ia {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  position: relative;
}
:ng-deep .ant-spin-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  position: relative;
}
.attach-button {
  cursor: pointer;
}
.upload-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  padding-top: 12px;
}
/*# sourceMappingURL=agent-builder-prompt.component.css.map */
